// API per dati tenant
export async function fetchTenantInfo() {
    const tenantId = localStorage.getItem('tenantId');
    if (!tenantId) throw new Error('Tenant non impostato');
    const { apiFetch } = await import('./client');
    const res = await apiFetch(`/api/tenant/${tenantId}`);
    if (!res.ok) throw new Error('Errore caricamento dati tenant');
    return res.json();
}

export async function updateTenantInfo(data: { name?: string; email?: string; password?: string }) {
    const { apiFetch } = await import('./client');
    const res = await apiFetch('/api/tenant/profile', { method: 'PUT', body: JSON.stringify(data) });
    if (!res.ok) {
        const err = await res.text();
        throw new Error(err || 'Errore aggiornamento dati tenant');
    }
    return res.json();
}